import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { useThemeStore } from '../../store/themeStore';
import { getDesignTokens } from '../../utils/designTokens';
import UserMenu from '../../components/UserMenu';

export default function MobileAccount() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const { isDarkMode } = useThemeStore();
  const tokens = getDesignTokens(isDarkMode);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="flex flex-col h-full">
      <div className="flex-shrink-0 px-4 py-3 border-b border-gray-200">
        <h1 className={`text-xl font-bold ${tokens.text.primary}`}>Account</h1>
        <p className={`text-sm ${tokens.text.muted}`}>
          Family management and settings
        </p>
      </div>
      <div className="flex-1 overflow-auto p-2">
        <div
          className={`max-w-lg mx-auto ${tokens.card.bg} ${tokens.card.border} border rounded-landing ${tokens.card.shadow} p-4`}
        >
          <UserMenu isDarkMode={isDarkMode} isEmbedded />
        </div>
      </div>
    </div>
  );
}
